import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { getAuditLogById } from '@/services/auditTrailService';

const EMPTY_COMMENTS = [];

// URL snapshots take precedence over legacy navigation state, including on failure.
export function useAuditSnapshot() {
  const location = useLocation();
  const auditLogId = new URLSearchParams(location.search).get('snapshot');
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!auditLogId) return;
    let cancelled = false;
    getAuditLogById(auditLogId)
      .then((entry) => {
        if (!entry?.snapshot) throw new Error('Snapshot unavailable');
        if (!cancelled) setResult({ auditLogId, entry });
      })
      .catch(() => {
        if (!cancelled) setResult({ auditLogId, error: true });
      });
    return () => { cancelled = true; };
  }, [auditLogId]);

  if (!auditLogId) {
    return {
      snapshotData: location.state?.snapshot || null,
      snapshotComments: location.state?.comments || EMPTY_COMMENTS,
      isLoading: false,
      error: false,
    };
  }

  const current = result?.auditLogId === auditLogId ? result : null;
  return {
    snapshotData: current?.entry?.snapshot || null,
    snapshotComments: current?.entry?.comments || EMPTY_COMMENTS,
    isLoading: !current,
    error: !!current?.error,
  };
}
